import { Box, ContentBlock, useColor } from 'braid-design-system';

import { BACKGROUND_DARK } from 'src/constants/styles';
import { ModuleTheme } from 'src/types';

export interface Props {
  id: string;
  theme?: ModuleTheme;
  children: any;
}

const PageSection = ({ id, theme = ModuleTheme.LIGHT, children }: Props) => {
  const { background } = useColor();
  return (
    <Box
      id={id}
      paddingY={['large', 'xlarge', 'xxlarge']}
      paddingX="gutter"
      style={{
        backgroundColor:
          theme === ModuleTheme.DARK ? BACKGROUND_DARK : background.surface,
      }}
    >
      <ContentBlock>{children}</ContentBlock>
    </Box>
  );
};

export default PageSection;
